<div *ngIf="!!file" fxFlex="100%" fxLayout="column" fxLayoutAlign="center stretch" class="file-preview-dialog" [ngClass]="{'framed': framed}">
  <div class="frame" fxFlex="100%">
    <pdf-viewer
      class="pdf-preview"
      *ngIf="file.type === 'application/pdf'; else showImage"
      [src]="fileSrc"
      [render-text]="false"
      [original-size]="false"
      [show-all]="false"
      [page]="1"
      [zoom]="1"
      [zoom-scale]="'page-width'"
      (after-load-complete)="loading = false"
    >
    </pdf-viewer>
    <ng-template #showImage>
      <div #imageElement fxFlex="100%" fxLayoutAlign="center" class="photo-preview-container"></div>
    </ng-template>
    <div class="border-color-primary border border--top border--left"></div>
    <div class="border-color-primary border border--top border--right"></div>
    <div class="border-color-primary border border--bottom border--left"></div>
    <div class="border-color-primary border border--bottom border--right"></div>
    <app-spinner *ngIf="loading"></app-spinner>
  </div>
  <div class="rules">
    <p>Antes de continuar verifique se:</p>
    <ul class="rules__list">
      <li class="rules__item"><strong>A foto não está borrada</strong></li>
      <li class="rules__item"><strong>O documento todo está dentro das bordas</strong></li>
    </ul>
  </div>
  <div *ngIf="!!data.okButton || !!data.noButton" class="container" fxLayout="row" fxLayoutAlign="space-between end" fxLayoutGap="16px">
    <button mat-stroked-button class="closecare-button primary-border" fxFlex="1 1 100%" (click)="onNoClicked()" color="primary">
      {{data.noButton}}
    </button>
    <button mat-raised-button cdkFocusInitial data-test="confirmation" class="closecare-button primary-bg" fxFlex="1 1 100%" *ngIf="data.okButton" (click)="onOkClicked()">
      {{data.okButton}}
    </button>
  </div>
</div>
<button mat-mini-fab class="close" color="primary" *ngIf="!data.okButton && !data.noButton" (click)="onNoClicked()">
  <mat-icon>close</mat-icon>
</button>
